import React, {Component} from 'react';
import {connect} from 'react-redux';
import SolicitorArticlesList from "../../components/articles/solicitorArticlesList";
import {
	changeSolicitorArticlesListSettings, pageShiftSolicitorArticles,
	requestGetAllArticlesSuggestions
} from "../../actions/solicitorArticlesList";
import {receiveGetArticles, requestArticlesMessage, requestGetArticleAttachment} from "../../actions/articlesList";
import {requestGetArticles} from "../../actions/articlesList";


class SolicitorArticlesListHOC extends Component {
	constructor(props){
		super(props);
		let askServer;
	}
	componentWillMount() {
		const parameters = this.getRequestParameters(this.props);
		this.askServer = setTimeout(()=>{this.props.requestGetArticles(parameters)},0);
	}

	componentWillReceiveProps = (nextProps) => {
		clearTimeout(this.askServer);
		if(this.props.solicitorArticlesList.fetchingDocument && !nextProps.solicitorArticlesList.fetchingDocument && nextProps.solicitorArticlesList.failedToGetDocumentMsg === ''){
			this.getFileFromBase64(nextProps.solicitorArticlesList.documentToDownload);
		}
		if(
			this.props.solicitorArticlesList.selectedView !== nextProps.solicitorArticlesList.selectedView ||
			this.props.solicitorArticlesList.value !== nextProps.solicitorArticlesList.value ||
			this.props.solicitorArticlesList.page !== nextProps.solicitorArticlesList.page
		) {
			let parameters = this.getRequestParameters(nextProps);
			if(
				this.props.solicitorArticlesList.value !== nextProps.solicitorArticlesList.value
				&& nextProps.solicitorArticlesList.value !==''
			){
				parameters.offset = 0;
				parameters.limit = 5;
				this.askServer = setTimeout(()=>{this.props.getAllArticlesSuggestions(parameters)},150);
			}else {
				this.props.requestGetArticles(parameters);
			}
		}
	};

	getRequestParameters = (props) => {
		const calcOffset = props.solicitorArticlesList.selectedView * (props.solicitorArticlesList.page -1);
		const parameters = {
			limit: props.solicitorArticlesList.selectedView,
			offset: calcOffset>0? calcOffset:0,
			published: true,
			unpublished: false,
			search: props.solicitorArticlesList.value !== '' ? props.solicitorArticlesList.value:null
		};
		return parameters;
	};

	onSuggestionsFetchRequested = ({value}) => {
		this.props.changeSolicitorArticlesListSettings('suggestions', this.getSuggestions(value))
	};

	getSuggestions = value => {
		return this.props.solicitorArticlesList.suggestions
	};


	onSuggestionsClearRequested = () => {
		if (this.props.solicitorArticlesList.value === '') {
			this.props.changeSolicitorArticlesListSettings('suggestions', []);
		}
	};

	getSuggestionValue = suggestion => suggestion !== undefined ?(suggestion.title !== '' ? suggestion.title : (suggestion.authorName !== '' ? suggestion.authorName:'')):null;

	renderSuggestion = suggestion => (
		<div>
			{suggestion.title !== '' ? suggestion.title + ' | ' : ''}{suggestion.authorName !== '' ? suggestion.authorName + ' | ' : '' }
		</div>
	);

	onChange = (event, {newValue}) => {
		event.preventDefault();
		if (typeof newValue !== 'undefined') {
			this.props.changeSolicitorArticlesListSettings('value', newValue);
			// if (newValue === '') {
			// 	this.props.changeSolicitorArticlesListSettings('suggestions', []);
			// }
		}
	};

	onArticleSuggestionSelected = (event, {suggestion, suggestionValue, suggestionIndex, sectionIndex, method}) => {
		if ( ( method === 'click' || (method === 'enter') ) && suggestion ) {
			let newValue = '';
			if(suggestion.title !==''){
				newValue = suggestion.title;
			}else if(suggestion.authorName !==''){
				newValue = suggestion.authorName;
			}
			let payload = {
				data: [suggestion],
				limit:0,
				offset:0,
				published:true,
				unpublished: false,
				totalRecords: 1
			};
			this.props.receiveGetArticles(payload);
			this.props.changeSolicitorArticlesListSettings('value', newValue? newValue.toString(): '' );
			this.props.changeSolicitorArticlesListSettings('suggestions', [suggestion]);

		}
	};

	handleAutoSuggestButton = (suggestion) => {
		let parameters = this.getRequestParameters(this.props);
		this.props.requestGetArticles(parameters);
	};

	render() {
		let value = this.props.solicitorArticlesList.value;
		const inputProps = {
			placeholder: '',
			value,
			onChange: this.onChange
		};

		return (
			<SolicitorArticlesList
				requestGetArticleAttachment = {this.props.requestGetArticleAttachment}
				suggestions={this.props.solicitorArticlesList.suggestions}
				onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
				onSuggestionsClearRequested={this.onSuggestionsClearRequested}
				getSuggestionValue={this.getSuggestionValue}
				renderSuggestion={this.renderSuggestion}
				inputProps={inputProps}
				onSuggestionSelected={this.onArticleSuggestionSelected}
				handleAutoSuggestButton={this.handleAutoSuggestButton}
				solicitorArticlesList={this.props.solicitorArticlesList}
				pageShiftSolicitorArticles={this.props.pageShiftSolicitorArticles}
				changeSolicitorArticlesListSettings={this.props.changeSolicitorArticlesListSettings}
				getArticles = {this.props.requestGetArticles}
			/>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		solicitorArticlesList: state.solicitorArticlesList
	}
};

const mapDispatchToProps = (dispatch) => {
	return {
		changeSolicitorArticlesListSettings: (key, value) => {
			dispatch(changeSolicitorArticlesListSettings(key, value))
		},
		pageShiftSolicitorArticles: (direction, totalBoxes) => {
			dispatch(pageShiftSolicitorArticles(direction, totalBoxes))
		},
		requestArticlesMessage: () => {
			dispatch(requestArticlesMessage())
		},
		requestGetArticleAttachment: (payload) => {
			dispatch(requestGetArticleAttachment(payload))
		},
		getAllArticlesSuggestions: (payload) => {
			dispatch(requestGetAllArticlesSuggestions(payload))
		},
		requestGetArticles: (payload) => {
			dispatch(requestGetArticles(payload))
		},
		receiveGetArticles: (payload) => {
			dispatch(receiveGetArticles(payload))
		}
	}
};

export default connect(mapStateToProps, mapDispatchToProps)(SolicitorArticlesListHOC);
